module.exports = __webpack_public_path__ + "static/media/err500.990ae4d0.svg";